import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import { configRepository } from '../../../const'
import Card from '../../common/Card'
import { getBranches } from '../../../Controller'
import {
  DeploymentProperties,
  PipelineState,
  Selector,
  RepositoryDeploymentProperties,
  StatusLine,
  ChangeDeploymentFunction
} from '../../../types'
import '../Deployment.css'
import { InstanceComponent } from './topControls/InstanceComponent'
import { DeploymentTableComponent } from './table/DeploymentTableComponent'

export function DeploymentUI(props: {
  repositories: RepositoryDeploymentProperties[]
  toDeploy: DeploymentProperties[]
  deploymentTag: string
  deploymentStatus: StatusLine
  pipelineStates: PipelineState[]
  pipelineSteps: Selector[]
  instance: string
  onInstanceChange: Function
  onDeployChange: ChangeDeploymentFunction
  onStartDeployment: Function
}) {
  const {
    repositories,
    toDeploy,
    deploymentTag,
    deploymentStatus,
    pipelineStates,
    pipelineSteps,
    instance,
    onInstanceChange,
    onDeployChange,
    onStartDeployment
  } = props

  const [fetchComponent, setFetchComponent] = useState(true)
  const [fetchTableComponent, setFetchTableComponent] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [instances, setInstances] = useState([] as string[])

  useEffect(() => {
    getBranches(configRepository).then(response => {
      if (response && response.success) {
        setInstances(response.result)
      }
    })
  }, [])

  useEffect(() => {
    if (!deploymentStatus.fetching) {
      if (deploymentTag && pipelineSteps.length > 0 && instance) {
        setFetchComponent(false)
        setFetchTableComponent(true)
        if (repositories.length > 0 && toDeploy.length > 0 && pipelineStates.length > 0) {
          if (toDeploy.length === repositories.length && repositories.length === pipelineStates.length) {
            setFetchTableComponent(false)
            setFetchComponent(false)
            setDisabled(false)
          }
        }
      }
    }
  }, [repositories, toDeploy, deploymentTag, pipelineStates, pipelineSteps, instance, deploymentStatus])

  function changeInstance(branch: string) {
    setDisabled(true)
    setFetchTableComponent(true)
    onInstanceChange(branch)
  }

  function startDeployment(selector?: Selector) {
    setDisabled(true)
    onStartDeployment(selector)
  }

  function renderDeploymentTableComponent() {
    if (fetchTableComponent) {
      return (
        <Box className='centerSpinner'>
          <CircularProgress className='spinner' size={60} />
          <Typography variant='subtitle1'>Fetching Data...</Typography>
        </Box>
      )
    }
    return (
      <DeploymentTableComponent
        disabled={disabled}
        toDeploy={toDeploy}
        repositories={repositories}
        pipelineStates={pipelineStates}
        onDeployChange={onDeployChange}
      />
    )
  }

  function renderInstanceComponent() {
    if (fetchComponent) {
      return (
        <Box className='centerSpinner'>
          <CircularProgress className='spinner' size={60} />{' '}
          <Typography variant='subtitle1'>Fetching Data...</Typography>
        </Box>
      )
    }
    return (
      <InstanceComponent
        disabled={disabled}
        deploymentTag={deploymentTag}
        deploymentStatus={deploymentStatus}
        instance={instance}
        instances={instances}
        onInstanceChange={changeInstance}
        onStartDeployment={startDeployment}
        pipelineSteps={pipelineSteps}
      />
    )
  }

  return (
    <Card title='Deployment' elevation={5}>
      {renderInstanceComponent()}
      {renderDeploymentTableComponent()}
    </Card>
  )
}

export default DeploymentUI
